import { render, staticRenderFns } from "./ShortfallSettlement.vue?vue&type=template&id=6d0f979a"
import script from "./ShortfallSettlement.vue?vue&type=script&lang=js"
export * from "./ShortfallSettlement.vue?vue&type=script&lang=js"
import style0 from "./ShortfallSettlement.vue?vue&type=style&index=0&id=6d0f979a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports